import React from 'react';
import { Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import Card from 'components/DesignSystem/Card';
import EditButton from 'components/Shared/EditButton';
import RichHtml from 'components/RichHtml';

import useSemanalSecaoParams from 'hooks/Relatorios/Semanal/useSemanalSecaoParams';
import { selectUserIsAdmin } from 'redux/reducers/authReducer';
import { useGetSemanalPremissasQuery } from 'services/api/products/relatorios';

export default function PremissasGerais() {
  const userIsAdmin = useSelector(selectUserIsAdmin);
  const params = useSemanalSecaoParams();

  const { data, isLoading } = useGetSemanalPremissasQuery(params);

  return (
    <Card
      className="h-100"
      title="PREMISSAS GERAIS"
      actions={userIsAdmin && (
        <EditButton id="edit-premissas-gerais" onClick={() => undefined} />
      )}
    >
      {isLoading && (
        <div className="d-flex justify-content-center p-3">
          <Spinner animation="border" role="status" />
        </div>
      )}
      {data && (
        <RichHtml html={data.conteudo_html} className="w-100 ql-editor" />
      )}
    </Card>
  );
}
